import React from 'react';
import { Button, Input, ModalBody, ModalFooter, TextArea } from 'freemium-ui';
import { useFormContext } from 'react-hook-form';
import Spacer from 'components/Spacer';
import { OnBoardingType } from '../../../../types';
import styled from 'styled-components';
import { SurveyTemplateDescriptionFormType } from 'shared/types';

const GetSurveyName = (props: {
  onSave: (data: OnBoardingType) => void;
  isLoading?: boolean;
  type: 'Template' | 'Survey';
}) => {
  const { onSave, type, isLoading } = props;
  const {
    register,
    formState: { errors, isDirty },
    handleSubmit,
    watch,
  } = useFormContext<SurveyTemplateDescriptionFormType>();

  const onSubmit = (data: SurveyTemplateDescriptionFormType) => {
    onSave({
      surveyInfo: {
        name: data.name,
        desc: data.desc,
      },
    });
  };

  return (
    <form>
      <ModalBody
        style={{
          textAlign: 'left',
          backgroundColor: '#fff',
          borderRadius: '4px',
        }}
      >
        <StyledSurveyForm>
          <h4>Give your {type.toLowerCase() || 'survey'} a name</h4>
          <Input
            label="Name"
            placeholder="Enter name"
            isRequired
            autoFocus
            maxLength={50}
            {...register('name')}
            isErrored={!!errors?.name}
            errorText={errors?.name?.message}
            endAdornment={`${watch('name')?.length ?? 0}/50`}
            showCount={false}
          />
          <Spacer />
          <TextArea
            {...register('desc')}
            className="align-adornment"
            label="Description"
            placeholder="Enter description"
            isErrored={!!errors?.desc}
            errorText={errors?.desc?.message}
            maxLength={300}
            endAdornment={`${watch('desc')?.length ?? 0}/300`}
            showCount={false}
          />
        </StyledSurveyForm>
      </ModalBody>
      <ModalFooter
        style={{
          backgroundColor: '#fff',
          border: 'none',
          padding: '24px 18px',
        }}
      >
        <Button
          disabled={!isDirty || isLoading}
          inline
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            handleSubmit(onSubmit, (err) => console.log('ERR', err))();
          }}
        >
          Save and next
        </Button>
      </ModalFooter>
    </form>
  );
};

export default GetSurveyName;

const StyledSurveyForm = styled.div`
  h4 {
    font-size: 1.1rem;
  }
  input {
    height: 36px;
  }
  .align-adornment {
    align-items: flex-end !important;
    flex-direction: column;

    textarea {
      min-height: 100px;
      width: 100%;
    }
  }
  .end-adornment {
    font-size: 12px;
    color: #323232;
    font-weight: 500;
    padding: 4px;
  }
  .close {
    position: absolute;
    right: 25px;
    top: 15px;
  }
`;
